import { Dialog, DialogContent } from "@mui/material";
import { MprcDialogTitleClose } from "components";
import { AutoCompleteDataModel } from "components/MprcAutoComplete";
import React from "react";
import { useTranslation } from "react-i18next";
import { NewDirectMessage } from "views/foundation/directMessage/NewDirectMessage";

interface IProps {
    sendToAll?: boolean;
    recipients?: AutoCompleteDataModel[];
    title?: string;
    onPost?: (subject: string, body: string) => Promise<boolean>;
    onClose: (success: boolean) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const NewDirectMessageDialog: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const { sendToAll = false, recipients, title, onPost, onClose } = props;

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <Dialog open fullWidth maxWidth="sm" onClose={() => onClose(false)}>
            <MprcDialogTitleClose
                title={t("DirectMessage.Title")}
                subtitle={title}
                onClose={() => onClose(false)}
                shrinkPadding
            />
            <DialogContent>
                <NewDirectMessage
                    allowSelectRecipients={sendToAll === false}
                    initialRecipients={recipients}
                    onPost={onPost}
                    onSend={() => onClose(true)}
                />
            </DialogContent>
        </Dialog>
    );
};
